import React from 'react'

interface IProps {
    children: React.ReactNode
    errorOverlay?: (err: Error) => React.ReactNode
    error?: boolean | Error
}

export default class TableOverlay extends React.Component<IProps> {
    state = {
        error: this.handleErrorState(),
        errorInfo: undefined,
    } as {
        error: Error | undefined
        errorInfo: React.ErrorInfo | undefined
    }

    private handleErrorState() {
        if (this.props.error) {
            if (this.props.error instanceof Error) {
                return this.props.error
            } else {
                return new Error('Ocorreu um erro inesperado')
            }
        }
        return undefined
    }

    static getDerivedStateFromError(error: Error) {
        return { error }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error(error)
        this.setState({ error, errorInfo })
    }

    componentDidUpdate(
        prevProps: Readonly<IProps>,
        _prevState: Readonly<unknown>,
        _snapshot?: any,
    ): void {
        if (prevProps.error !== this.props.error)
            this.setState(prev => ({ ...prev, error: this.handleErrorState() }))
    }

    render() {
        if (this.state.error) {
            if (this.props.errorOverlay)
                return (
                    <TableFrame>
                        {this.props.errorOverlay(this.state.error)}
                    </TableFrame>
                )

            return (
                <TableFrame>
                    <span
                        className="text-destructive font-semibold text-2xl mb-2"
                        title="Erro ao exibir tabela"
                    >
                        Erro ao exibir tabela
                    </span>
                    <span
                        title={this.state.error.toString()}
                        className="text-sm text-secondary mb-2 p-8 overflow-y-auto max-h-full"
                    >
                        {this.state.error.toString()}
                    </span>
                </TableFrame>
            )
        }

        return this.props.children
    }
}

function TableFrame({ children }: { children: React.ReactNode }) {
    return (
        <div className="size-full flex flex-col items-center justify-center">
            {children}
        </div>
    )
}
